const initialState = {
    transactionDate:"",
    mon:"",
    cancelDate:"", 
    expireBrtcForm:false  
}

function brtc(state = initialState, action) {
    switch (action.type) {  
        case 'UPDATE_BRTCINFO':
            return Object.assign({}, state, {
                transactionDate: action.value.dateOfTransaction,
                mon : action.value.mon,
                cancelDate  : action.value.cancelDate,
            })
        case 'EXPIRE_BRTCINFO':
            return Object.assign({}, state, {
                expireBrtcForm: action.value
            })
        default:
              return state
            }
        }
export default brtc